import React from 'react';
import ServicePage from '../../components/ServicePage';
import { Target, Globe, Smartphone, Server, Package, Wifi, FileCheck, Search, Crosshair, Map, Award } from 'lucide-react';

export default function PenTest() {
  return (
    <ServicePage
      title="渗透测试服务"
      subtitle="全链路 APT 模拟 · 漏洞发现率高于纯工具扫描 3 倍 · 分级修复路线图"
      description="卓迈渗透测试团队由 OSCP、CEH 认证专家组成，平均从业 10 年以上。我们不做「走过场」的渗透，而是完整模拟 APT 攻击链路——从信息收集、初始突破到横向渗透、权限提升，真实评估企业安全边界。漏洞发现率高于市场同类工具扫描 3 倍，报告按严重程度和修复难度分级，直接交付可执行的修复路线图。"
      icon={<Target size={40} strokeWidth={1.5} />}
      color="#6930e8"
      benefits={[
        '全链路 APT 攻击模拟，而非仅工具扫描',
        'OSCP + CEH 认证红队专家执行',
        '漏洞发现率高于纯工具扫描 3 倍',
        '覆盖 Web、APP、API、内网横向等场景',
        '按严重程度分级的可执行修复路线图',
      ]}
      features={[
        {
          icon: <Globe size={24} />,
          title: 'Web 应用渗透',
          desc: '完整覆盖 OWASP Top 10 + CWE/SANS Top 25，涵盖 SQL 注入、XSS、CSRF、IDOR、SSRF、文件上传、反序列化等所有主流漏洞类型，支持 SPA、RESTful API、GraphQL 场景。',
          points: ['OWASP Top 10 全覆盖', 'API 接口深度测试', '业务逻辑漏洞挖掘', '越权与水平越权测试'],
        },
        {
          icon: <Smartphone size={24} />,
          title: 'APP 与移动端测试',
          desc: 'Android / iOS 双平台逆向分析，流量劫持、证书绑定绕过、本地数据安全审计，覆盖客户端 + 服务端完整攻击面，出具 APP 专项安全报告。',
          points: ['APK/IPA 逆向分析', '中间人流量拦截', '本地存储安全审计', '客户端+服务端双向测试'],
        },
        {
          icon: <Server size={24} />,
          title: '内网横向渗透',
          desc: '获得初始立足点后，模拟真实 APT 横向移动路径——Pass the Hash、Kerberoasting、ACL 滥用、域控提权，评估内网隔离策略的实际有效性。',
          points: ['Active Directory 攻击', 'PTH / PTT 横向移动', '域控权限提升测试', 'VLAN 隔离有效性验证'],
        },
        {
          icon: <Package size={24} />,
          title: '供应链安全测试',
          desc: '针对开源组件、第三方库、CI/CD 流水线的供应链攻击路径测试，识别 npm/pip/Maven 依赖中的已知 CVE，评估 DevOps 环境的安全配置。',
          points: ['SCA 软件成分分析', 'CI/CD 管道安全审计', 'Container 安全评估', 'Secret 泄露检测'],
        },
        {
          icon: <Wifi size={24} />,
          title: '无线与物理测试',
          desc: '企业 Wi-Fi 安全评估（WPA2 企业级、PEAP 配置审计）、蓝牙与 IoT 设备安全测试，以及物理边界渗透（机房门禁、社会工程学）。',
          points: ['Wi-Fi 企业级安全审计', 'IoT 设备固件分析', '蓝牙协议安全测试', '社会工程学评估'],
        },
        {
          icon: <FileCheck size={24} />,
          title: '分级修复路线图',
          desc: '所有漏洞按 CVSS 3.1 评分，并结合业务影响进行二次优先级排序，输出《渗透测试报告》（攻击者视角）+ 《修复路线图》（开发运维视角），不让报告躺在抽屉里。',
          points: ['CVSS 3.1 漏洞评分', '业务风险二次排序', '修复 POC 与示例代码', '修复验证复测服务'],
        },
      ]}
      process={[
        { icon: <Map size={24} />, title: '目标确认', desc: '签署授权书，明确测试范围、边界条件、时间窗口，杜绝越权测试' },
        { icon: <Search size={24} />, title: '信息收集', desc: 'OSINT + 主动探测，建立目标资产全息图，识别暴露面优先级' },
        { icon: <Crosshair size={24} />, title: '漏洞利用', desc: '专家手工 + 工具组合，完整模拟 APT 攻击链路，记录完整攻击路径' },
        { icon: <Award size={24} />, title: '深度控制', desc: '横向移动、权限提升，验证最大危害场景，评估业务影响半径' },
        { icon: <FileCheck size={24} />, title: '报告交付', desc: '提交双版本报告（技术版+管理层摘要），附分级修复路线图' },
      ]}
      nextService={{ name: '应急响应服务', path: '/services/emergency-response' }}
    />
  );
}
